import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazySignIn = loadable(() => import(/* webpackChunkName: "content/createwedding-sign-in" */ './SignIn'), 'SignIn');
